import { useToaster } from '@innovationdepartment/proxima-ui';
import { IntegrationsStoreLoader } from 'components/Loaders';
import { useProximaSDK, useShowSpinner } from 'hooks';
import { SKIP_ENTITLEMENT_GATE } from 'hooks/localDevBypass';
import { useEffect, useState } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router';
import { useBrandStore } from 'stores';

const BrandLoader = () => {
  const navigate = useNavigate();
  const { brandId } = useParams();

  const brandApi = useProximaSDK('BrandsApi');
  const { updateBrandStore } = useBrandStore();
  const { showToaster } = useToaster();

  const [loading, setLoading] = useState(true);

  useShowSpinner({ show: loading });

  const showError = (msg?: string) => {
    const errorMsg = msg ?? 'Something went wrong, please try again';
    showToaster({ message: errorMsg, variant: 'error' });
  };

  /* let's fetch brand info if all went well */
  // biome-ignore lint/correctness/useExhaustiveDependencies: pre-Biome migration; the app is already working as expected with these dependency arrays
  useEffect(() => {
    if (!brandId) return;

    const fetchBrandInfo = async () => {
      setLoading(true);

      try {
        const response = await brandApi.getBrand({ brandId });

        if (response.status === 200) {
          const brandData = response.data;
          updateBrandStore(brandData, true);
        } else {
          showError();
        }
      } catch {
        if (SKIP_ENTITLEMENT_GATE) {
          /* no brand read entitlement locally: stub the brand so brand pages still render */
          updateBrandStore({ brandId, name: `Brand ${brandId} (local stub)`, domain: '' }, true);
        } else {
          showError();
          navigate('/brands', { replace: true });
        }
      }
      setLoading(false);
    };

    fetchBrandInfo();
  }, [brandId]);

  /* return to brand selection */
  if (!brandId) {
    navigate('/brands');
    return null;
  }

  if (loading) return null;

  return (
    <IntegrationsStoreLoader>
      <Outlet />
    </IntegrationsStoreLoader>
  );
};

export default BrandLoader;
